import React from "react";
import LandingHero from "./LandingHero";
import LandingTopCard from "./LandingTopCard";
import LandingBottomCard from "./LandingBottomCard";
import LandingTopText from "./LandingTopText";
import LandingBottomText from "./LandingBottomText";
import LandingSchedule from "./LandingSchedule";
import LandingVideo from "./LandingVideo";
import LandingSkills from "./LandingSkills";
import { Helmet } from "react-helmet-async";
import { getWeekendInfoByName } from "../../backend/weekends/weekendInfo";

interface Props {
  weekendId: number;
}

const LandingPage = ({ weekendId }: Props) => {
  return (
    <>
      <Helmet>
        <title>{getWeekendInfoByName(weekendId,"metaTitle")}</title>
        <meta name="description" content={getWeekendInfoByName(weekendId,"metaDescription")} />
      </Helmet>
      <div style={styles.landingPageWrapper}>
        <LandingHero weekendId={weekendId} />
        <LandingTopCard  weekendId={weekendId} />
        <LandingBottomCard  weekendId={weekendId} />
        <LandingVideo  weekendId={weekendId} />
        <LandingSchedule  weekendId={weekendId} />
        <LandingSkills  weekendId={weekendId} />
        <LandingTopText  weekendId={weekendId} />
        <LandingBottomText  weekendId={weekendId} />
      </div>
    </>
  );
};

const styles: Record<string, React.CSSProperties> = {
  landingPageWrapper: {
    overflow: "hidden",
    marginTop: "var(--header-height)",
  },
};

export default LandingPage;
